import ApiService from './ApiService';

class WorkflowAccOpeningService {
  async prepareIndividualAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/prepare_individual_account_opening',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async saveIndividualAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/save_individual_account_opening',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async submitIndividualAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/submit_individual_account_opening',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async approveIndividualAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/approve_individual_account_opening',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async deleteAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/delete_account_opening',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async getIndividualAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/get_individual_account_opening',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async getIndividualAccList(payload) {
    try {
      const response = await ApiService.call(
        '/secured/get_individual_account_opening_list',
        'POST',
        payload,
      );
      console.log(response.result);

      return {
        traderList: response.result.map(data => {
          return {
            applicationNo: data.applicationInfo.applicationNo,
            clientType: data.applicationInfo.clientType,
            tradingAccountNo: data.individualAccountOpeningData.tradingAccountNo,
            primaryEmail: data.individualAccountOpeningData.primaryEmail,
            firstName: data.individualProfile.firstName,
            lastName: data.individualProfile.lastName,
            middleName: data.individualProfile.middleName,
            nameOnIdentity: data.individualProfile.nameOnIdentity,
            identityValue: data.individualProfile.identityValue,
            identityType: data.individualProfile.identityType,
            traderId: data.individualAccountOpeningData.workflowId,
            stage: data.individualAccountOpeningData.stage,
          };
        }),
        totalCount: response.totalCount,
        page: response.offset,
        size: response.size,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async prepareCorporateAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/prepare_corporate_account_opening',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async saveCorporateAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/save_corporate_account_opening',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async submitCorporateAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/submit_corporate_account_opening',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async approveCorporateAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/approve_corporate_account_opening',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async getCorporateAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/get_corporate_account_opening',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async getCorporateAccList(payload) {
    try {
      const response = await ApiService.call(
        '/secured/get_corporate_account_opening_list',
        'POST',
        payload,
      );

      return {
        traderList: response.result.map(data => {
          return {
            applicationNo: data.applicationInfo.applicationNo,
            clientType: data.applicationInfo.clientType,
            firmName: data.corporateProfile.firmName,
            registrationNo: data.corporateProfile.registrationNo,
            tradingAccountNo: data.corporateAccountOpeningData.tradingAccountNo,
            primaryEmail: data.corporateAccountOpeningData.primaryEmail,
            stage: data.corporateAccountOpeningData.stage,
            traderId: data.corporateAccountOpeningData.workflowId,
          };
        }),
        totalCount: response.totalCount,
        page: response.offset,
        size: response.size,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async addCorporateDirector(payload) {
    try {
      const response = await ApiService.call('/secured/add_corporate_director', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async modifyCorporateDirector(payload) {
    try {
      const response = await ApiService.call(
        '/secured/modify_corporate_director_account_opening',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async addCorporateAuthorizedPerson(payload) {
    try {
      const response = await ApiService.call(
        '/secured/add_corporate_authorized_person',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async modifyCorporateAuthorizedPerson(payload) {
    try {
      const response = await ApiService.call(
        '/secured/modify_corporate_authorized_person_account_opening',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async addCorporateCompanyOwner(payload) {
    try {
      const response = await ApiService.call(
        '/secured/add_corporate_company_owner',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async modifyCorporateCompanyOwner(payload) {
    try {
      const response = await ApiService.call(
        '/secured/modify_corporate_company_owner_account_opening',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async removeCorporateDirector(payload) {
    try {
      const response = await ApiService.call('/secured/remove_corporate_director', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async removeCorporateAuthPerson(payload) {
    try {
      const response = await ApiService.call(
        '/secured/remove_corporate_authorized_person',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async removeCorporateCompanyOwner(payload) {
    try {
      const response = await ApiService.call(
        '/secured/remove_corporate_company_owner',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async generateCorporateDocument(payload = {}) {
    try {
      const response = await ApiService.call(
        '/secured/upload_corporate_account_opening_document',
        'POST',
        payload,
      );
      let data = response;

      return {
        uploadUrl: data.uploadUrl,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async generateIndividualDocument(payload = {}) {
    try {
      const response = await ApiService.call(
        '/secured/upload_individual_account_opening_document',
        'POST',
        payload,
      );
      let data = response;

      return {
        uploadUrl: data.uploadUrl,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new WorkflowAccOpeningService();
